import { DataText } from './data-text.tsx';
import { NumberOrEmpty } from './number-or-empty.tsx';

type QuantityTextProps = {
    quantity: number | undefined | null;
    unit: string | undefined | null;
};

export function QuantityText({ quantity, unit }: QuantityTextProps) {
    return (
        <span>
            <DataText>
                <NumberOrEmpty>{quantity}</NumberOrEmpty>
            </DataText>
            {unit && ` ${unit}`}
        </span>
    );
}
